<template>
	<div class="contain">
		<img class="imgs" src="../../../assets/c17/guide01.png" alt="솔닥 약국 방문 수령 방법 안내 step 01(아래글 참고)" />
		<img class="imgs" src="../../../assets/c17/guide02.png" alt="솔닥 약국 방문 수령 방법 안내 step 02, step 03(아래글 참고)" />
		<img class="imgs" src="../../../assets/c17/guide03.png" alt="솔닥 약국 방문 수령 방법 안내 step 04, step 05(아래글 참고)" />
		<div class="sr-only">
			<div>
				<h2>솔닥 약국 방문 수령 방법 안내</h2>
				<p><strong>쉽고 간단한 조제약 약국 방문 수령 방법</strong> 지금바로 알려드려요!</p>
				<div>
					<span>비대면진료 자격 1</span>
					<h3>휴일과 야간에는 누구나 초진부터 비대면 진료를 받을 수 있어요</h3>
					<ul>
						<li>
							<strong><span>step 01</span>약 수령할 약국 선택하기</strong>
							<p>지도 상에서 방문할 약국을 직접 선택하고 [이 약국으로 처방전 보내기] 버튼을 클릭하세요</p>
						</li>
						<li>
							<strong><span>step 02</span>수령 시간 선택 후 처방전 보내기</strong>
							<p>약국 방문 시간을 선택하고 [이 약국으로 처방전 보내기] 버튼을 클릭하세요</p>
							<span>약국 변경이 필요할 때 [ 내역 확인하기 ] 클릭 후 화면에서 처방전을 회수하고 약국을 다시 선택할 수 있어요</span>
						</li>
						<li>
							<strong><span>step 03</span>약국에 조제 요청하기</strong>
							<p>약국에서 처방전을 확인하면 카카오 알림톡이 도착해요 알림톡 내 [ 조제 요청하기 ] 버튼을 클릭하세요</p>
						</li>
						<li>
							<strong><span>step 04</span>조제 요청 완료하기</strong>
							<p>해당 화면 [ 조제 요청하기 ] 버튼으로 조제 요청이 완료되며 조제 과정을 확인할 수 있어요</p>
							<span>조제 요청 완료 이후에는 약국 변경이 불가능해요.</span>
						</li>
						<li>
							<strong><span>step 05</span>약국에서 약 수령하기</strong>
							<p>약국 조제 완료 카카오 알림톡이 도착하면 약국에서 약을 수령 할 수 있어요</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "c17",
	methods: {}
};
</script>

<style scoped>
.contain {
	width: 100%;
	position: relative;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
}
.imgs {
	width: 100%;
}
.last-img {
	padding-bottom: 150px;
}
.pb_5 {
	padding-bottom: 20px;
}
.contain .sr-only {
	position: absolute;
	left: -9999px;
	width: 1px;
	height: 1px;
	margin: 0 !important;
	font-size: 0;
	line-height: 0;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_view/contents/c17.vue